export default __webpack_public_path__ + "static/media/0x7bebd226154e865954a87650faefa8f485d36081.8fe9f7cf.webp";